import * as VerificationConstants from './constants';
import * as D from './deps';

export function discountOrgSearchAutocomplete({ discountType, inputText }) {
  return D.Api.apiRequest({
    serviceHostType: D.Constants.Api.ServiceHostTypes.SHEER_ID,
    endpoint: D.Constants.Api.ApiEndpoints.DISCOUNT_ORG_SEARCH_AUTOCOMPLETE,
    method: 'get',
    excludeAuthTokenInHeader: true,
    excludeCsrfTokenInHeader: true,
    withCredentials: false,
    responseType: D.Constants.Api.ApiResponseTypes.PLAINTEXT,
    params: {
      type: VerificationConstants.discountTypeToOrgSearchAutocompleteType[discountType],
      name: inputText,
      nameStartAnchored: false,
      city: null,
      state: null,
      country: null,
      accountId: null,
      accountScopeOnly: null,
      tag: null,
      includeLocation: false,
    },
  });
}

export function submitDiscountVerification({
  discountType,
  email,
  firstName,
  lastName,
  birthDate,
  organizationId,
  affiliationType = null,
  statusStartYear = null,
}) {
  const normalizedAffiliationType = affiliationType || null;
  const normalizedStatusStartYear = statusStartYear || null;
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.SUBMIT_DISCOUNT_VERIFICATION,
    content: D.Api.deleteNullParams({
      discountType,
      email,
      firstName,
      lastName,
      birthDate,
      organizationId,
      affiliationType: normalizedAffiliationType,
      statusStartYear: normalizedStatusStartYear,
    }),
  });
}
